import { gql } from "@apollo/client";

export const REMOVE_EXCUSE = gql`
  mutation removeExcuse($_id: String!) {
    removeExcuse(_id: $_id)
  }
`;
